export class Permissions {
    // MAKE ALL FALSE ONCE TESTING IS DONE
    HasPermisos13 = false;
    HasPermisos311 = false;
    HasPermisos314 = false;
    HasPermisos501 = false;
    HasPermisos505 = false;
    HasPermisos513 = false;
    HasPermisos519 = false;
    HasPermisos520 = false;
    HasPermisos525 = false;
    HasPermisos601 = false;
    HasPermisos602 = false;
    HasPermisos605 = false;
    HasPermisos604 = false;
    HasPermisos607 = false;
    HasPermisos608 = false;
    HasPermisos609 = false;
    HasPermisos612 = false;
    HasPermisos614 = false;
    HasPermisos615 = false;
    HasPermisos616 = false;
    HasPermisos618 = false;
    HasPermisos619 = false;
    HasPermisos623 = false;
    HasPermisos627 = false;
    HasPermisos212 = false;
    HasPermisos223 = false;
    HasPermisos306 = false;
    HasPermisos515 = false;
    HasPermisos350 = false;
    HasPermisos521 = false;
    HasPermisos1006 = false;
    HasPermisos620 = false;
    HasPermisos856 = false;
}
